import { WEBPAGE } from "../main_config";

const menuItems = [
  {
    key: "nosotros",
    label: "Sobre Nosotros",
    static: true,
    elemens: [
      { key: "st/nuestra-empresa", label: "Nuestra empresa", external: true, url: `${WEBPAGE}/st/nuestra-empresa`, last: false },
      { key: "st/unidades-moviles", label: "Unidades móviles", external: true, url: `${WEBPAGE}/st/unidades-moviles`, last: false },
      { key: "st/centrales-comunicacion", label: "Central de comunicación", external: true, url: `${WEBPAGE}/st/centrales-comunicacion`, last: true },
    ]
  },
  { key: "st/productos", label: "Productos", external: true, url: `${WEBPAGE}/st/productos`, static: false },
  {
    key: "info",
    label: "Información útil",
    static: true,
    elemens: [
      { key: "st/telefonos-utiles", label: "Teléfonos útiles", external: true, url: `${WEBPAGE}/st/telefonos-utiles`, last: false },
      { key: "sucursales", label: "Sucursales", external: true, url: `${WEBPAGE}/sucursales`, last: false },
      { key: "notas", label: "Notas", external: true, url: `${WEBPAGE}/notas`, last: false },
      { key: "st/emergencias", label: "Qué hacer en una emergencia", external: true, url: `${WEBPAGE}/st/emergencias`, last: false },
      { key: "st/formas-de-pago", label: "Formas de pago", external: true, url: `${WEBPAGE}/st/formas-de-pago`, last: false },
      { key: "st/como-leer-tu-factura", label: "¿Cómo leer tu factura?", external: true, url: `${WEBPAGE}/st/como-leer-tu-factura`, last: true},
    ]
  },
  { key: "productos/consulta", label: "Quiero Asociarme", external: true, url: `${WEBPAGE}/productos/consulta`, static: false },
];

export default menuItems;
